// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { IqbhMapComponent } from './iqbh-map.component';
import { UIModule } from 'libraries/ui/ui.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { MapModule } from 'libraries/map/map.module';
import { HotelResumeModule } from 'libraries/hotel/components/hotel-resume/hotel-resume.module';
import { CardModule } from 'libraries/ui_card/card.module';
import { MapComputationModule } from 'libraries/map/computation/map-computation.module';
import { BtnModule } from 'libraries/ui_button/btn.module';

@NgModule({
    declarations: [
        IqbhMapComponent,
    ],
    imports: [
        CommonModule,
        UIModule,
        CardModule,
        LoaderModule,
        MapModule,
        HotelResumeModule,
        MapComputationModule,
        BtnModule,
    ],
    exports: [
        IqbhMapComponent,
    ],
    providers: [],
})
export class IqbhMapModule { }
